/**
 * Generic Utility Functions
 */
